import styled from 'styled-components';

import {getColor, ms} from '../../../../styles';
import {Clickable} from '../../../../uikit/Clickable';
import {Text as TextBase} from '../../../../uikit/Text';
import {View} from '../../../../uikit/View';
import {MODAL_CLASS_NAMES} from '../../constants';

export const Wrapper = styled(View).attrs({
  className: MODAL_CLASS_NAMES.headerWrapper,
})`
  flex-direction: column;
  position: relative;
  top: 0;
  z-index: 3;
`;

export const Container = styled(View).attrs({
  className: MODAL_CLASS_NAMES.header,
})<{modalPadding: number}>`
  align-items: flex-start;
  background: ${getColor('background.white')};
  gap: ${ms(10)};
  justify-content: space-between;
  padding-block: ${ms(20)} ${ms(16)};
  padding-inline: ${p => ms(p.modalPadding)};

  @media screen and (max-width: 480px) {
    font-size: 16px;
    padding: ${ms(15)} ${ms(20)};
  }
`;

export const Content = styled(View)`
  gap: ${ms(10)};
  align-items: center;
  min-width: 0;
`;

export const Close = styled(Clickable).attrs({
  className: MODAL_CLASS_NAMES.closeButton,
})``;

export const Text = styled(TextBase).attrs({variant: 'h2', weight: 'bold'})``;
